import { render } from "./ProgressMetric.vue?vue&type=template&id=cf386458"
import script from "./ProgressMetric.vue?vue&type=script&lang=js"
export * from "./ProgressMetric.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ProgressMetric.vue"]])

export default __exports__